export default '/build/b563ffce.png'